import { Button, Col, Row } from "reactstrap"
import { ContentBlock } from "../../../Shared/Content/ContentBlock"
import { useOidc } from "@axa-fr/react-oidc";
import { ReadyLink } from "./ReadyLink";
import { NavigationBox } from "./NavigationBox";

export interface IWhatsNextProps {
    fleetID?: string,
    isSampleFleet?: boolean,
    isAuthenticated?: boolean
}

export const WhatsNext = ({ fleetID, isSampleFleet }: IWhatsNextProps) => {
    const { isAuthenticated } = useOidc();

    return (
        <Row className="whatsNextContainer">
            <Col>
                <ContentBlock className="whatsNextSection componentPadding">
                    <Row className="whatsNextHeading">
                        <Col lg={10} md={10} sm={12} className="textCol">
                            {isAuthenticated ? (
                                isSampleFleet ? (
                                    <p>
                                        Now that you've reviewed the results for this sample fleet, here are ideas for your next move:
                                    </p>
                                ) : (
                                    <p>
                                        Excellent! You've completed your fleet electrification estimate.<br />Here are ideas for your next move:
                                    </p>
                                )
                            ) : ( //Anonymous user is always sample fleet.
                                <p>
                                    Now that you've reviewed the results for this sample fleet, here are ideas for your next move:
                                </p>
                            )}
                        </Col>
                        <Col lg={2} md={2} sm={12} className="buttonCol">
                            <Button className="submitButton hollowNeg tertiaryButton iconRightArrow" onClick={() => window.open(`/PrintResults/${fleetID}`, '_blank')}>Print Results</Button>
                            <div className="printBrowserMessage">
                                with Chrome or Edge for best print quality
                            </div>
                        </Col>
                    </Row>
                    {isAuthenticated ? (
                        <Row className="whatsNextBody">
                            <Col lg={4} md={12} sm={12}>
                                <ReadyLink />
                            </Col>
                            <Col lg={8} md={12} sm={12}>
                                <NavigationBox isSampleFleet={isSampleFleet} isAuthenticated={isAuthenticated} />
                            </Col>
                        </Row>
                    ) : ( //Anonymous user is always sample fleet.
                        <Row className="whatsNextBody">
                            <Col lg={8} md={12} sm={12}>
                                <NavigationBox isSampleFleet={isSampleFleet} isAuthenticated={isAuthenticated} />
                            </Col>
                            <Col lg={4} md={12} sm={12}>
                                <ReadyLink />
                            </Col>
                        </Row>
                    )}
                </ContentBlock>
            </Col>
        </Row>
    );
}